export const LAYOUT_CONTENT_ID = 'layoutContent';
